const type = 'SET_MODAL_SUBMITTING';

const setModalSubmitting = () => ({
  type,
});

export { type };
export default setModalSubmitting;
